import { PDFViewer } from '@react-pdf/renderer'
import useAbility, { AbilityReportType } from '@/hooks/use-ability'
import { ExportRanchesData } from './_data/mock-ranch-data'
import { RanchReportPDF } from './pdf-report-ranch'
import { ParcelSingleReportPDF } from './pdf-report-parcel'
import { ExportData } from './_data/mock-data'

export type PDFReportFeatureProps = {
  data: any
  ability: AbilityReportType
  type: 'parcel' | 'ranch'
}

export default function PDFPage() {
  const { getAbilityReport, isLoading } = useAbility()

  if (isLoading) return <></>

  return (
    <PDFViewer style={{ width: '100%', height: '100vh' }}>
      {/* <RanchReportPDF data={ExportRanchesData} ability={getAbilityReport()} /> */}
      <ParcelSingleReportPDF data={ExportData} ability={getAbilityReport()} />
    </PDFViewer>
  )
}
